'use client';

import { FC, useEffect } from 'react';

import { APP_ENV } from '@/environment/app.interface';

const platform = 'storyblok';

export interface GoogleTagManagerEventsProps {
  env: APP_ENV;
  pageId: number | string;
  pathname: string;
}

export const GoogleTagManagerEvents: FC<GoogleTagManagerEventsProps> = ({
  env,
  pageId,
  pathname,
}) => {
  const environment = env === APP_ENV.STAGE ? 'staging' : 'production';

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    const page_id = pageId.toString();
    const page_url = window.location.href;
    const path = window.location.pathname;
    const page_name = ['portal:con', ...path.split('/')]
      .filter(Boolean)
      .join('|');

    const page_referrer = document.referrer;
    const query = window.location.search;

    const event = {
      event: 'pageview',
      event_name: 'page_view',
      page: {
        environment,
        platform,
        page_id,
        page_referrer,
        page_name,
        page_url,
        query,
      },
    };

    window.dataLayer.push(event);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return null;
};
